/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPracticeDetailsForPatient200Response
 */
export interface GetPracticeDetailsForPatient200Response {
}

/**
 * Check if a given object implements the GetPracticeDetailsForPatient200Response interface.
 */
export function instanceOfGetPracticeDetailsForPatient200Response(value: object): value is GetPracticeDetailsForPatient200Response {
    return true;
}

export function GetPracticeDetailsForPatient200ResponseFromJSON(json: any): GetPracticeDetailsForPatient200Response {
    return GetPracticeDetailsForPatient200ResponseFromJSONTyped(json, false);
}

export function GetPracticeDetailsForPatient200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPracticeDetailsForPatient200Response {
    return json;
}

export function GetPracticeDetailsForPatient200ResponseToJSON(json: any): GetPracticeDetailsForPatient200Response {
    return GetPracticeDetailsForPatient200ResponseToJSONTyped(json, false);
}

export function GetPracticeDetailsForPatient200ResponseToJSONTyped(value?: GetPracticeDetailsForPatient200Response | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

